module.exports = __webpack_public_path__ + "static/media/kara-connect.89dce2ee.png";